import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["recipientId", "searchContainer", "searchInput", "selectedContainer", "typeSelect"]

  connect() {
    // Initialisiere basierend auf vorhandenem recipient_type
    if (this.hasTypeSelectTarget && this.typeSelectTarget.value) {
      this.typeChanged()
    }
    
    // Höre auf Custom Events vom subjectable-search Controller
    if (this.hasSearchContainerTarget) {
      this.searchContainerTarget.addEventListener('subjectable-search:selected', this.handleRecipientSelected.bind(this))
    }
    
    // Lade vorhandenen Empfänger wenn recipient_id bereits gesetzt ist
    if (this.hasRecipientIdTarget && this.recipientIdTarget.value && this.hasTypeSelectTarget && this.typeSelectTarget.value) {
      this.loadExistingRecipient()
    }
  }
  
  loadExistingRecipient() {
    if (!this.hasRecipientIdTarget || !this.recipientIdTarget.value) return
    if (!this.hasTypeSelectTarget || !this.typeSelectTarget.value) return
    
    const recipientId = this.recipientIdTarget.value
    const recipientType = this.typeSelectTarget.value
    
    // Lade den Empfänger über subjectable_search API
    fetch(`/backend/subjectable_search?ids=${recipientId}&type=${recipientType}`)
      .then(r => r.json())
      .then(results => {
        if (results && results.length > 0) {
          const recipient = results[0]
          
          // Setze den Wert im Suchfeld
          if (this.hasSearchInputTarget) {
            this.searchInputTarget.value = recipient.display_name || recipient.name || 'Unknown'
          }
          
          // Zeige den ausgewählten Empfänger an
          if (this.hasSearchContainerTarget) {
            const subjectableSearchController = this.application.getControllerForElementAndIdentifier(
              this.searchContainerTarget,
              'subjectable-search'
            )
            
            if (subjectableSearchController) {
              subjectableSearchController.displaySelectedSubjectables([recipient])
            }
          }
        }
      })
      .catch(error => {
        // Silent error handling
      })
  }

  disconnect() {
    if (this.hasSearchContainerTarget) {
      this.searchContainerTarget.removeEventListener('subjectable-search:selected', this.handleRecipientSelected.bind(this))
    }
  }

  typeChanged() {
    if (!this.hasTypeSelectTarget) return

    const selectedType = this.typeSelectTarget.value
    
    // Aktiviere/Deaktiviere das Suchfeld basierend auf Typ-Auswahl
    if (this.hasSearchInputTarget) {
      this.searchInputTarget.readOnly = !selectedType
      this.searchInputTarget.placeholder = selectedType ? `Suchen nach ${this.getTypeLabel(selectedType)}...` : 'Bitte wählen Sie zuerst einen Typ aus'
    }

    // Setze den Typ im subjectable-search Controller
    if (this.hasSearchContainerTarget) {
      const subjectableSearchController = this.application.getControllerForElementAndIdentifier(
        this.searchContainerTarget,
        'subjectable-search'
      )
      
      if (subjectableSearchController) {
        // Setze den selectedType im subjectable-search Controller
        if (selectedType) {
          subjectableSearchController.selectedType = selectedType
          subjectableSearchController.updateTypeSelector()
        } else {
          subjectableSearchController.selectedType = null
          subjectableSearchController.updateTypeSelector()
        }
      }
    }

    // Leere die Auswahl wenn Typ geändert wird
    if (this.hasRecipientIdTarget) {
      this.recipientIdTarget.value = ''
    }
    
    // Leere das Suchfeld
    if (this.hasSearchInputTarget) {
      this.searchInputTarget.value = ''
    }

    // Leere die Anzeige der ausgewählten Subjectables
    if (this.hasSelectedContainerTarget) {
      this.selectedContainerTarget.innerHTML = ''
    }
    
    // Leere auch das subjectable_ids Feld
    if (this.hasSearchContainerTarget) {
      const idsField = this.searchContainerTarget.querySelector('input[name*="[subjectable_ids]"]')
      if (idsField) {
        idsField.value = ''
      }
    }
  }

  getTypeLabel(type) {
    switch(type) {
      case 'Contact': return 'Kontakt'
      case 'Applicant': return 'Bewerber'
      case 'Customer': return 'Kunde'
      case 'Talent': return 'Talent'
      default: return type
    }
  }

  // Wird aufgerufen wenn ein Ergebnis ausgewählt wird
  handleRecipientSelected(event) {
    // Das Event kommt vom subjectable-search Controller
    // Wir müssen die Daten aus dem subjectable_ids Feld extrahieren
    if (this.hasSearchContainerTarget) {
      const idsField = this.searchContainerTarget.querySelector('input[name*="[subjectable_ids]"]')
      if (idsField && idsField.value) {
        // Format: "id:type"
        const entry = idsField.value.split(',')[0]
        const [id, type] = entry.split(':')
        
        if (id && this.hasRecipientIdTarget) {
          this.recipientIdTarget.value = id
        }
      }
    }
  }

  recipientSelected(event) {
    this.handleRecipientSelected(event)
  }
}

